import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { AlertWarningTriangleIcon } from '@calendly/ui/components/icons';
import { Popup, Header, Body, Footer, Title } from '@calendly/ui/components/popup';
import { colorIconDestructive } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
const centerIconCss = "c1hjfwni";
const CenterIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(centerIconCss, props.className)} />;
});
export const ConfirmationPopup = ({
  close,
  confirm
}) => <Popup onClose={close}>
    <Header>
      <CenterIcon>
        <AlertWarningTriangleIcon size="x-large" color={colorIconDestructive} />
      </CenterIcon>
      <Title>
        {I18n.t('publisher.organization_settings.data_deletion.confirmation.title')}
      </Title>
    </Header>
    <Body>
      {I18n.t('publisher.organization_settings.data_deletion.confirmation.description')}
    </Body>
    <Footer>
      <Button decoration="secondary-outline" onClick={close}>
        {I18n.t('publisher.action.cancel')}
      </Button>
      <Button onClick={confirm} decoration="danger">
        {I18n.t('publisher.action.yes')}
      </Button>
    </Footer>
  </Popup>;

require("./confirmation_popup.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./confirmation_popup.js");